import React from 'react';
import { Button, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface Props {
  /** Fila 1, izquierda: título y selector de vista (lo monta la página, igual en todas las vistas). */
  cabecera?: React.ReactNode;
  /** Fila 1, derecha: lo propio de la vista (p. ej. «Por enviar / Enviados», «Sale a las 09:00», «Abrir portal»). */
  acciones?: React.ReactNode;
  /** Fila 2, izquierda: los filtros de la vista (tipo, estado, fechas…). */
  filtros?: React.ReactNode;
  /** Fila 2, derecha: buscador y «Actualizar», siempre juntos. */
  children?: React.ReactNode;
}

const fila: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 };
const grupo: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 };

/**
 * Barra superior de las vistas del panel Encuestas CX, en DOS filas fijas e iguales en las cuatro vistas:
 *   1. cabecera (título + vista) a la izquierda · acciones de la vista a la derecha;
 *   2. filtros a la izquierda · buscador y «Actualizar» a la derecha.
 * Antes era una sola fila con salto libre: según el ancho (portátil o monitor) cada control caía en una línea
 * distinta y la barra se reordenaba. Ahora cada grupo tiene su sitio; si la pantalla es estrecha, un grupo baja
 * entero bajo el anterior, pero el orden no cambia.
 */
const BarraLista: React.FC<Props> = ({ cabecera, acciones, filtros, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 }}>
    <div style={{ ...fila, justifyContent: 'space-between' }}>
      <div style={grupo}>{cabecera}</div>
      {acciones && <div style={grupo}>{acciones}</div>}
    </div>
    {(filtros || children) && (
      <div style={{ ...fila, justifyContent: 'space-between' }}>
        <div style={grupo}>{filtros}</div>
        {children && <div style={{ ...grupo, flexWrap: 'nowrap', marginLeft: 'auto' }}>{children}</div>}
      </div>
    )}
  </div>
);

/** Ancho del buscador: fijo, para que la fila no baile al cambiar de pantalla. */
export const ESTILO_BUSCADOR: React.CSSProperties = { width: 280 };

/** «Actualizar» de las vistas: botón primario del tema (lima con icono verde oscuro), como en el resto de GescomAux. */
export const BotonActualizar: React.FC<{ onClick: () => void; loading?: boolean }> = ({ onClick, loading }) => (
  <Tooltip title="Actualizar">
    <Button type="primary" icon={<ReloadOutlined />} onClick={onClick} loading={loading} aria-label="Actualizar" />
  </Tooltip>
);

export default BarraLista;
